
import { useEffect, useState } from 'react';
import { fetchGetpaddlenlp } from '../../api/pages/paddlenlpApi'
import { Coreprops } from './components/core/type'
import { Advprops } from './components/advantage/type'
import { Advnprops } from './components/advantagen/type'
import { Modelprops } from './components/model/type'
// 预请求
let preRequest: any = {
    fetchGetpaddlenlp: fetchGetpaddlenlp()
};

const usePaddleNlpHooks = () => {
    const [introduce, setintroduce] = useState<string>('');
    const [coerpation, setcorepation] = useState<Coreprops>({});
    const [treeduce, settreeduce] = useState<string>('');
    const [treepic, settreepic] = useState<string>('');
    const [advantage, setadvantage] = useState<Advprops>({});
    const [advantagen, setadvantagen] = useState<Advnprops>({});
    const [more, setmore] = useState<string>('');

    const [model, setmodel] = useState<Modelprops>({});

    useEffect(() => {
        (async () => {
            const res = await (preRequest.fectchGetpaddlenlp || fetchGetpaddlenlp())
                .catch(() => {
                    //ingore
                })
            delete preRequest.fectchGetpaddlenlp;
            if (res) {
                const data = res.body.result.pageData || {};
                setintroduce(data.InfoCard?.desc ?? '');
                settreeduce(data.tree?.desc ?? '');
                const apm = data.core || {};
                const apmList: any[] = Array.isArray(apm.list) ? apm.list : [];
                setcorepation({
                    list: apmList.map((item) => ({
                        btnLink: item.btnLink,
                        btnText: item.btnText,
                        text: item.text,
                        title: item.title,
                        img: item.img,
                        imageUrl: item.imageUrl,
                        btnLinkt: item.btnLinkt,
                        btnTextt: item.btnTextt,
                    })),
                });
                settreepic(data.treepic?.imageUrl ?? '');
                const adv = data.advantage || {};
                const advList: any[] = Array.isArray(adv.list) ? adv.list : [];
                setadvantage({
                    list: advList.map((item) => ({
                        text: item.text,
                        title: item.title,
                        img: item.img,
                        imageUrl: item.imageUrl
                    })),
                });
                const advn = data.advantagen || {};
                const advnList: any[] = Array.isArray(advn.list) ? advn.list : [];
                setadvantagen({
                    list: advnList.map((item) => ({
                        text: item.text,
                        title: item.title,
                        img: item.img,
                        imageUrl: item.imageUrl
                    })),
                });
                const model = data.model || {}
                const modelList: any[] = Array.isArray(model.list) ? model.list : [];
                setmodel({
                    list: modelList.map((item) => ({
                        text: item.text,
                        title: item.title,

                    })),
                })
                // const more = data.more || {};
                // console.log(more)
                setmore(data.more?.detailLink ?? '');
            }
        })()
    }, [
        setintroduce,
        setcorepation,
        settreeduce,
        settreepic,
        setadvantage,
        setmodel,
        setadvantagen,
        setmore
    ])
    return {
        introduce,
        coerpation,
        treeduce,
        treepic,
        advantage,
        model,
        advantagen,
        more
    }
};

export default usePaddleNlpHooks;
